export default "__VITE_ASSET__CwMz3nY1__"